import ClassFeesManagement from "@/views/payments/ClassFeesManagement.vue";
import AddClassFee from "@/views/payments/AddClassFee.vue";
import EditClassFee from "@/views/payments/EditClassFee.vue";
import PaymentReceipts from "@/views/payments/PaymentReceipts.vue";
import PaymentReceiptForm from "@/views/payments/PaymentReceiptForm.vue";
import DiscountForm from "@/views/payments/DiscountForm.vue";

export default [
  {
    path: '/class-fees',
    name: 'class-fees.index',
    component: ClassFeesManagement,
    meta: { 
      title: 'classFees.indexTitle',
      requiresAuth: true,
      requiredPerm: 'class_fees.display'
    },
    children: [
      {
        path: 'add',
        name: 'class-fees.add',
        component: AddClassFee,
        meta: { 
          title: 'classFees.addTitle',
          requiresAuth: true,
          requiredPerm: 'class_fees.create'
        }
      },
      {
        path: 'edit/:id',
        name: 'class-fees.edit',
        component: EditClassFee,
        meta: { 
          title: 'classFees.editTitle',
          requiresAuth: true,
          requiredPerm: 'class_fees.update'
        },
        props: true
      }
    ]
  },

  {
    path: '/payment-receipts',
    name: 'payment-receipts.index',
    component: PaymentReceipts,
    meta: { 
      title: 'paymentReceipts.indexTitle',
      requiresAuth: true,
      requiredPerm: 'payment_receipts.display'
    },
    children: []
  },
  {
    path: '/payment-receipts/create',
    name: 'payment-receipts.create',
    component: PaymentReceiptForm,
    meta: { 
      title: 'paymentReceipts.addTitle',
      requiresAuth: true,
      requiredPerm: 'payment_receipts.create',
      breadcrumbParents: [
        { name: 'payment-receipts.index', title: 'paymentReceipts.indexTitle' },
      ],
    }
  },
  {
    path: '/payment-receipts/:id/edit',
    name: 'payment-receipts.edit',
    component: PaymentReceiptForm,
    meta: { 
      title: 'paymentReceipts.editTitle',
      requiresAuth: true,
      requiredPerm: 'payment_receipts.update',
      breadcrumbParents: [
        { name: 'payment-receipts.index', title: 'paymentReceipts.indexTitle' },
      ],
    },
    props: true
  },
  {
    path: '/payment-receipts/discount',
    name: 'payment-receipts.discount',
    component: DiscountForm,
    meta: {
      title: 'paymentReceipts.discountTitle',
      requiresAuth: true,
      requiredPerm: 'payment_receipts.create',
      breadcrumbParents: [
        { name: 'payment-receipts.index', title: 'paymentReceipts.indexTitle' },
      ],
    }
  }
];
